import {
  FETCH_FRIENDS_LOADING,
  FETCH_FRIENDS_SUCCESS,
  FETCH_MORE_FRIENDS_LOADING,
  FETCH_MORE_FRIENDS_SUCCESS,
  FETCH_FRIENDS_ERROR,
  FETCH_FRIEND_REQUESTS_SUCCESS,
  INITIATE_UNFRIEND_CONFIRMATION,
  CANCEL_UNFRIEND_CONFIRMATION,
  REMOVE_OR_DENY_FRIEND_LOADING,
  REMOVE_OR_DENY_FRIEND_SUCCESS,
  REMOVE_OR_DENY_FRIEND_ERROR,
  ACCEPT_FRIEND_REQUEST_LOADING,
  ACCEPT_FRIEND_REQUEST_SUCCESS,
  FIND_FRIENDS_LOADING,
  FIND_FRIENDS_SUCCESS,
  SEARCH_USERS_LOADING,
  SEARCH_USERS_SUCCESS,
  SEARCH_USERS_ERROR,
  ADD_FRIEND_LOADING,
  ADD_FRIEND_SUCCESS,
  FETCH_MORE_SUGGESTED_FRIENDS_LOADING,
  FETCH_MORE_SUGGESTED_FRIENDS_SUCCESS,
  RESET_FRIEND_API_OFFSETS,

} from './constants'

import createReducer from '../createReducer'

export const initialState = {
  myFriends: [],
  totalFriends: 0,
  myFriendRequests: [],
  myFriendsLoading: true,
  getMoreFriendsLoading: false,
  noFriends: false,
  myFriendsError: false,
  myFriendsNextLink: null,
  userToUnfriend: {
    displayName: '',
    id: 0,
  },
  confirmUnfriend: false,
  removeFriendIsLoading: false,
  userIdCurrentlyAccepting: 0,
  isDenyingFriendRequest: false,
  findFriendsLoading: true,
  pendingFriendRequests: [],
  suggestedFriends: [],
  mySuggestedFriendsOffset: 0,
  noMoreSuggestions: false,
  isGettingMoreSuggestedFriends: false,
  searchResults: [],
  noSearchResults: false,
  searchLoading: false,
  userIdCurrentlyAdding: 0,
}

export default createReducer(initialState, {
  [FETCH_FRIENDS_LOADING]: (state) => {
    return { ...state, myFriendsLoading: true }
  },

  [FETCH_FRIENDS_ERROR]: (state) => {
    return { ...state, myFriendsLoading: false, myFriendsError: true }
  },

  [FETCH_FRIENDS_SUCCESS]: (state, action) => {
    const data = action.payload.data
    const noFriends = data.total_count === 0
    let nextLink = null

    if (data._links.hasOwnProperty('next')) {
      nextLink = data._links.next[0].href
    }

    return {
      ...state,
      myFriends: data._embedded.user,
      myFriendsLoading: false,
      myFriendsNextLink: nextLink,
      totalFriends: data.total_count,
      noFriends: noFriends,
    }
  },

  [FETCH_MORE_FRIENDS_LOADING]: (state) => {
    return { ...state, getMoreFriendsLoading: true }
  },

  [FETCH_MORE_FRIENDS_SUCCESS]: (state, action) => {
    const data = action.payload.data
    let nextLink = null

    if (data._links.hasOwnProperty('next')) {
      nextLink = data._links.next[0].href
    }

    return {
      ...state,
      myFriends: [...state.myFriends, ...data._embedded.user],
      myFriendsNextLink: nextLink,
      getMoreFriendsLoading: false,
      totalFriends: data.total_count,
    }
  },

  [FETCH_FRIEND_REQUESTS_SUCCESS]: (state, action) => {
    return {
      ...state,
      myFriendRequests: action.payload.data._embedded.user,
    }
  },

  [INITIATE_UNFRIEND_CONFIRMATION]: (state, action) => {
    return {
      ...state,
      userToUnfriend: action.userToUnfriend,
      confirmUnfriend: true,
      isDenyingFriendRequest: action.isDenyingFriendRequest,
    }
  },

  [CANCEL_UNFRIEND_CONFIRMATION]: (state) => {
    return { ...state, confirmUnfriend: false }
  },

  [REMOVE_OR_DENY_FRIEND_LOADING]: (state) => {
    return { ...state, removeFriendIsLoading: true }
  },

  [REMOVE_OR_DENY_FRIEND_SUCCESS]: (state, action) => {
    const filteredRequests = state.myFriendRequests.filter((friendRequest) => {
      return friendRequest.id !== action.meta.userIdToRemove
    })

    const filteredFriends = state.myFriends.filter((friend) => {
      return friend.id !== action.meta.userIdToRemove
    })

    const filteredPendingRequests = state.pendingFriendRequests.filter((pendingRequest) => {
      return pendingRequest.id !== action.meta.cancelledFriendRequestId
    })

    const newFriendCount = state.isDenyingFriendRequest ? state.totalFriends : state.totalFriends - 1

    return {
      ...state,
      myFriends: filteredFriends,
      myFriendRequests: filteredRequests,
      confirmUnfriend: false,
      removeFriendIsLoading: false,
      totalFriends: newFriendCount,
      pendingFriendRequests: filteredPendingRequests,
    }
  },

  [REMOVE_OR_DENY_FRIEND_ERROR]: (state) => {
    return { ...state, confirmUnfriend: false }
  },

  [ACCEPT_FRIEND_REQUEST_LOADING]: (state, action) => {
    return { ...state, userIdCurrentlyAccepting: action.meta.newFriend.id }
  },

  [ACCEPT_FRIEND_REQUEST_SUCCESS]: (state, action) => {
    const filteredRequests = state.myFriendRequests.filter((friendRequest) => {
      return friendRequest.id !== action.meta.newFriend.id
    })

    const newFriendCount = state.totalFriends + 1

    return {
      ...state,
      myFriendRequests: filteredRequests,
      myFriends: [action.meta.newFriend, ...state.myFriends],
      acceptFriendLoading: false,
      totalFriends: newFriendCount,
    }
  },

  [FIND_FRIENDS_LOADING]: (state) => {
    return { ...state, findFriendsLoading: true }
  },

  [FIND_FRIENDS_SUCCESS]: (state, action) => {
    const { payload } = action
    const pendingFriendRequests = payload[0].action.payload.data._embedded.user
    const suggestedFriends = payload[1].action.payload.data._embedded.user

    const friendRequestIds = pendingFriendRequests.map((request) => request.id)

    const filteredSuggestions = suggestedFriends.filter((suggestion) => {
      return !friendRequestIds.includes(suggestion.id)
    })

    return {
      ...state,
      pendingFriendRequests: pendingFriendRequests,
      suggestedFriends: filteredSuggestions,
      findFriendsLoading: false,
    }
  },

  [SEARCH_USERS_LOADING]: (state) => {
    return {
      ...state,
      searchResults: [],
      searchLoading: true,
      noSearchResults: false,
    }
  },

  [SEARCH_USERS_ERROR]: (state) => {
    return {
      ...state,
      searchLoading: false,
    }
  },

  [SEARCH_USERS_SUCCESS]: (state, action) => {
    const searchResults = action.payload.data._embedded.user

    // Ensure that pending friends do not show up in search results
    const friendRequestIds = state.pendingFriendRequests.map((request) => request.id)

    // Also, add the current user ot this list so they are not included in the search results, either
    friendRequestIds.push(action.meta.currentUserId)

    const filteredSearchResults = searchResults.filter((result) => {
      return !friendRequestIds.includes(result.id)
    })

    const noSearchResults = filteredSearchResults.length === 0
    return {
      ...state,
      searchResults: filteredSearchResults,
      searchLoading: false,
      noSearchResults: noSearchResults,
    }
  },

  [ADD_FRIEND_LOADING]: (state, action) => {
    return {
      ...state,
      userIdCurrentlyAdding: action.meta.friend.id,
    }
  },

  [ADD_FRIEND_SUCCESS]: (state, action) => {
    // Filter newly requested friend out of either suggested friends, or search results
    const friend = action.meta.friend

    const filteredSearchResults = state.searchResults.filter((searchedUser) => {
      return searchedUser.id !== friend.id
    })

    const filteredSuggestedFriends = state.suggestedFriends.filter((suggestedFriend) => {
      return suggestedFriend.id !== friend.id
    })

    // And add him or her to pending requests
    return {
      ...state,
      searchResults: filteredSearchResults,
      suggestedFriends: filteredSuggestedFriends,
      pendingFriendRequests: [friend, ...state.pendingFriendRequests],
      userIdCurrentlyAdding: 0,
    }
  },

  [FETCH_MORE_SUGGESTED_FRIENDS_LOADING]: (state) => {
    return {
      ...state,
      isGettingMoreSuggestedFriends: true,
    }
  },

  [FETCH_MORE_SUGGESTED_FRIENDS_SUCCESS]: (state, action) => {
    const newFriendSuggestions = action.payload.data._embedded.user
    const suggestedFriends = [...state.suggestedFriends, ...newFriendSuggestions]
    const noMoreSuggestions = state.suggestedFriends.length === suggestedFriends.length

    return {
      ...state,
      suggestedFriends: [...state.suggestedFriends, ...newFriendSuggestions],
      mySuggestedFriendsOffset: action.meta.newOffset,
      noMoreSuggestions: noMoreSuggestions,
      isGettingMoreSuggestedFriends: false,
    }
  },

  [RESET_FRIEND_API_OFFSETS]: (state) => {
    return {
      ...state,
      mySuggestedFriendsOffset: 0,
    }
  },
})
